import { useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core';
import tinycolor from 'tinycolor2';

interface Props {
  [key: string]: any;
  color: string;
}

const useStyles = makeStyles(() => ({
  outerCircle: {
    display: 'flex',
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    width: '24px',
    height: '24px',
    border: '1px solid'
  },
  innerCircle: {
    zIndex: 100,
    borderRadius: '50%',
    transform: 'none',
    filter: 'none',
    width: '14px',
    height: '14px',
    margin: '1px'
  }
}));
const ColorElement = ({ color, ...props }: Props) => {
  const [lightColor, setLightColor] = useState<string>(tinycolor(color).lighten(30).toString());
  const classes = useStyles();

  useEffect(() => {
    setLightColor(tinycolor(color).lighten(30).toString());
  }, [color]);

  return (
    <div
      className={classes.outerCircle}
      style={{
        borderColor: color,
        backgroundColor: lightColor
      }}
      {...props}
    >
      <div
        className={classes.innerCircle}
        style={{
          backgroundColor: color
        }}
      />
    </div>
  );
};

export default ColorElement;
